/**
 * Check if the browser supports flexbox gap property
 * @returns {boolean} Returns true if flexbox gap is supported, false otherwise
 */
const supportsFlexGap = () => {
  const div = document.createElement('div');
  div.style.display = 'flex';
  div.style.flexDirection = 'column';
  div.style.rowGap = '1px';
  div.appendChild(document.createElement('div'));
  div.appendChild(document.createElement('div'));
  document.body.appendChild(div);
  const supportsGap = div.scrollHeight === 1;
  document.body.removeChild(div);
  return supportsGap;
};

/**
 * Check if the system browser needs an update based on flexbox gap support
 * @returns {boolean} Returns true if the browser needs an update, false otherwise
 */
const checkSystemBrowserNeedUpdate = () => {
  const isSupportedFlexGap = supportsFlexGap();
  return !isSupportedFlexGap;
};

export default checkSystemBrowserNeedUpdate;
